import React from 'react';

import { useRouter } from 'next/router';
import styled from 'styled-components';

import { useMembership } from '@techstyle/react-accounts';
import { FormattedMessage } from '@techstyle/react-intl';
import { useSession } from '@techstyle/redux-core';

const DynamicFormattedMessage = FormattedMessage;

const BottomTextContainer = styled.div`
  padding: 20px 20px ${props => props.theme.spacing.large}px 20px;
  border-top: 1px solid ${props => props.theme.colors.gray200};
  h1,
  h2 {
    ${props => props.theme.header.variants.h2.textStyles}
  }
  p {
    font-size: 14px;
    font-weight: 300;
    line-height: 20px;
    letter-spacing: 0.3px;
  }
`;

const ProductBottomText = () => {
  const { asPath } = useRouter();

  const normalizeCategoryPath = urlPath => {
    const [, ...categories] = urlPath.split('/').filter(str => str !== '');
    return categories.join('_').replace(/[-/]/g, '_');
  };

  const bottomRbCategory = normalizeCategoryPath(asPath);
  const { networkStatus } = useMembership();
  const { isLoggedIn } = useSession();

  const shouldShowBottomText =
    networkStatus.isUpToDate && !isLoggedIn && bottomRbCategory;

  if (!shouldShowBottomText) {
    return null;
  }

  return (
    <BottomTextContainer>
      <DynamicFormattedMessage
        id={`site_product_grid.bottom_text_${bottomRbCategory}`}
        defaultMessage="<h1>Savage X Fenty</h1><p>Rihanna's Savage X Fenty celebrates fearlessness, confidence and inclusivity. We want you to feel sexy and have fun doing it. With offerings ranging from everyday basics to more provocative pieces - Savage X Fenty is lingerie for everyone.</p>"
      />
    </BottomTextContainer>
  );
};

export default ProductBottomText;
